import { useContext } from "react";
import { useQuery } from "react-query";
import { AuthContext } from "../../Context/AuthContext";

const fetchVesselById = async (id, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/vessel/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(errorResponse.message || "Failed to fetch vessel data");
  }
  return response.json();
};

export const useFetchVesselById = (id) => {
  const { token } = useContext(AuthContext);

  return useQuery(["vessel", id], () => fetchVesselById(id, token), {
    onError: (error) => {
      console.error("Error fetching vessel data:", error);
    },
  });
};
